export default class ProcessOptionsService {
  static instance = new ProcessOptionsService();
  id: string | undefined;
  values: { [key: string]: string | undefined } = {};
}
